module.exports = __webpack_public_path__ + "static/media/logo.12106f0b.svg";